import React from 'react';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Trackable } from '@/components/common';

type TicketInfo = {
  code: string;
  name: string;
  desc: string;
  price: string;
  singleton: any;
  maxBookingsAllowed: string;
  maxSeats: string;
  isWeekend: any;
  isAllDays: boolean;
  dates: any[];
  date: string;
  selected_ticket: number;
};

interface TProps {
  selectedTickets: any;
  handleAddToCart: () => void;
  eventType: string;
}

const CartSummary = ({ selectedTickets, handleAddToCart, eventType }: TProps) => {
  if (!Object.keys(selectedTickets || {}).length) return null;

  const totalAmount = Object.values(selectedTickets).reduce(
    (sum: number, item: any) => sum + item.selected_ticket * item.price,
    0,
  );

  type TicketData = Record<string, TicketInfo>;

  function calculateTotalSelectedTickets(data: TicketData): number {
    return Object.values(data).reduce((total, item) => {
      return total + (item.selected_ticket || 0);
    }, 0);
  }
  const totalSelectedTickets = calculateTotalSelectedTickets(selectedTickets);

  return (
    <div className='sticky bottom-0 left-0 z-20 flex w-full flex-col items-center border-t bg-white px-8 py-4'>
      <div className='flex w-full max-w-2xl justify-between p-2'>
        <div>
          <Label className='text-xl font-bold'>
            {eventType === 'FREE_FCFS' ? 'FREE' : `₹ ${totalAmount}`}
          </Label>
          <div className='text-sm text-gray-500'>{`${totalSelectedTickets} ticket(s)`}</div>
        </div>
        <div className='flex gap-5'>
          <Trackable
            eventName='Click'
            eventScope='Add to Cart'
            eventProps={{
              'Selected Tickets': selectedTickets,
              'Total Amount': totalAmount,
            }}
          >
            <Button
              className='h-12 font-semibold rounded-xl'
              onClick={() => handleAddToCart()}
            >
              ADD TO CART
            </Button>
          </Trackable>
        </div>
      </div>
    </div>
  );
};

export default CartSummary;
